import React, { useEffect, useMemo, useState } from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router-dom';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import DescriptionIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import ProductionQuantityLimitsOutlinedIcon from '@mui/icons-material/ProductionQuantityLimitsOutlined';
import DirectionsBoatFilledOutlinedIcon from '@mui/icons-material/DirectionsBoatFilledOutlined';
import BalanceOutlinedIcon from '@mui/icons-material/BalanceOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import ViewModuleOutlinedIcon from '@mui/icons-material/ViewModuleOutlined';
import ColorLensOutlinedIcon from '@mui/icons-material/ColorLensOutlined';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import GroupWorkOutlinedIcon from '@mui/icons-material/GroupWorkOutlined';
import ArticleIcon from '@mui/icons-material/Article';
import CampaignIcon from '@mui/icons-material/Campaign';
import FeedbackIcon from '@mui/icons-material/Feedback';
import WorkIcon from '@mui/icons-material/Work';
import { t } from '../constants/translationHelper';

const ContentWrapper = styled('section')(({ theme }) => ({
    padding: theme.spacing(0),
}));

const CustomCard = styled(Card)(({ theme }) => ({
    minHeight: '325px',
    maxHeight: '400px',
    transition: 'transform 0.2s, box-shadow 0.2s',
    '&:hover': {
        transform: 'scale(1.05)',
        boxShadow: theme.shadows[1],
    },
}));

const CardBody = styled(CardContent)(({ theme }) => ({
    padding: theme.spacing(3),
}));

const Heading = styled(Typography)(({ theme }) => ({
    fontWeight: 600,
}));

const CustomLink = styled(RouterLink)(({ theme }) => ({
    display: 'flex',
    fontWeight: 600,
    fontSize: "12px",
    alignItems: 'center',
    color: theme.palette.text.primary,
    textDecoration: 'none',
    marginTop: theme.spacing(1),
    transition: 'color 0.2s',
    '&:hover': {
        color: '#0652DD',
        textDecoration: 'underline',
    },
}));



const cards = [
    {
        title: 'GENERAL',
        links: [
            { to: '/app/personalsettings', icon: <PersonOutlineOutlinedIcon />, text: 'Personal Settings' },
            { to: '/app/mycompany', icon: <BusinessOutlinedIcon />, text: 'Company Settings' },
            { to: '/app/companybank', icon: <AccountBalanceOutlinedIcon />, text: 'Company Bank' },
            { to: '/app/usermanagement', icon: <SecurityOutlinedIcon />, text: 'User Management' },

        ],
    },
    {
        title: 'Security Control',
        links: [
            // { to: '/app/companyusers', icon: <SupervisedUserCircleOutlinedIcon />, text: 'Company Users' },
            // { to: '/app/securitycontrols', icon: <SecurityOutlinedIcon />, text: 'Security Controls' },

            { to: '/app/profiles', icon: <PersonOutlineOutlinedIcon />, text: 'Profiles' },
            { to: '/app/roles', icon: <GroupOutlinedIcon />, text: 'Roles And Sharing' },
            { to: '/app/systemCompany', icon: <SettingsOutlinedIcon />, text: 'System Setting' },
            { to: '/app/termConditions', icon: <GavelOutlinedIcon />, text: 'Terms & Conditions ' },
            // { to: '/app/adminusers', icon: <PersonOutlineOutlinedIcon />, text: 'Admin Users' },
        ],
    },
    {
        title: 'Master',
        links: [
            { to: '/app/portMasters', icon: <DirectionsBoatFilledOutlinedIcon />, text: 'Port Masters' },
            { to: '/app/partyLedger', icon: <AccountBalanceOutlinedIcon />, text: 'Party Ledger' },
            { to: '/app/expenseledgergroup', icon: <AccountBalanceOutlinedIcon />, text: 'Expense Ledger Group' },
            { to: '/app/shippinglinemaster', icon: <DirectionsBoatFilledOutlinedIcon />, text: 'Shipping Line Master' },
            { to: '/app/freightforwardmaster', icon: <GroupWorkOutlinedIcon />, text: 'Freight Forward Master' },
            { to: '/app/customclearingagency', icon: <GroupWorkOutlinedIcon />, text: 'Custom Clearing Agency' },
            // { to: '/app/financialyear', icon: <DescriptionIcon />, text: 'Financial Year' },
            // { to: '/app/currencymaster', icon: <DescriptionIcon />, text: 'Currency Master' },
            // { to: '/app/prefixsuffix', icon: <DescriptionIcon />, text: 'Prefix Suffix' },
        ],
    },
    {
        title: 'Products',
        links: [
            { to: '/app/productsgroup', icon: <CategoryOutlinedIcon />, text: 'Products Group' },
            { to: '/app/manageproducts', icon: <ProductionQuantityLimitsOutlinedIcon />, text: 'Manage Products' },
            { to: '/app/unitmaster', icon: <BalanceOutlinedIcon />, text: 'Unit Master' },
        ],
    },
    {
        title: 'Business Master',
        links: [
            { to: '/app/businessgroup', icon: <CategoryOutlinedIcon />, text: 'Business Group' },
            { to: '/app/contactgroup', icon: <CategoryOutlinedIcon />, text: 'Contact Group' },
            { to: '/app/contacttypes', icon: <CategoryOutlinedIcon />, text: 'Contact Types' },
            // { to: '/app/companygroup', icon: <StoreIcon />, text: 'Company Group' },
            // { to: '/app/companytype', icon: <DescriptionIcon />, text: 'Company Type' },
            // { to: '/app/leadstages', icon: <DescriptionIcon />, text: 'Lead Stages' },
            // { to: '/app/fcl', icon: <DescriptionIcon />, text: 'FCL' },
            // { to: '/app/direct', icon: <DescriptionIcon />, text: 'Direct' },
            // { to: '/app/paymenttype', icon: <DescriptionIcon />, text: 'Payment Type' },
        ],
    },
    {
        title: 'Status Master',
        links: [
            { to: '/app/taskstatuses', icon: <DescriptionIcon />, text: 'Task Statuses' },
            { to: '/app/ratings', icon: <DescriptionIcon />, text: 'Ratings' },
            { to: '/app/statusesleads', icon: <DescriptionIcon />, text: 'Lead Statuses' },
            { to: '/app/sourceslead', icon: <DescriptionIcon />, text: 'Lead Sources' },
            { to: '/app/lossreasons', icon: <DescriptionIcon />, text: 'Loss Reasons' },
            { to: '/app/priorities', icon: <DescriptionIcon />, text: 'Priorities' },
            // { to: '/app/calloutcometypes', icon: <DescriptionIcon />, text: 'Call Outcome Types' },
            // { to: '/app/callpurposetypes', icon: <DescriptionIcon />, text: 'Call Purpose Types' },
            // { to: '/app/ownershiptypes', icon: <DescriptionIcon />, text: 'Ownership Type' },
            // { to: '/app/supplierslist', icon: <DescriptionIcon />, text: 'Suppliers List' },
            // { to: '/app/currencylist', icon: <DescriptionIcon />, text: 'Currency List' },
            // { to: '/app/shipmenttypes', icon: <DescriptionIcon />, text: 'Shipment Types' },
            // { to: '/app/ciffoblist', icon: <DescriptionIcon />, text: 'CIF/FOB List' },
        ],
    },
    {
        title: 'Customization',
        links: [
            // { to: '/app/companymodules', icon: <DescriptionIcon />, text: 'Module Settings' },
            { to: '/app/modules', icon: <ViewModuleOutlinedIcon />, text: 'Modules' },
            { to: '/app/template', icon: <PrintOutlinedIcon />, text: 'Template' },
            { to: '/app/colorplate', icon: <ColorLensOutlinedIcon />, text: 'Color Plate' },
        ],
    },
    {
        title: 'Subscription Plans',
        links: [
            { to: '/app/subscription', icon: <AccountBalanceOutlinedIcon />, text: 'Subscription Plans' },
            { to: '/app/subscriptionHistory', icon: <AccountBalanceOutlinedIcon />, text: 'Subscription History' },
            // { to: '/app/setUp', icon: <ViewModuleIcon />, text: 'SetUp' },
        ],
    },
];

const cardsAlexxcansols = [
    {
        title: 'GENERAL',
        links: [
            { to: '/alexxcansols/personalsettings', icon: <PersonOutlineOutlinedIcon />, text: 'Personal Settings' },
            { to: '/alexxcansols/mycompany', icon: <BusinessOutlinedIcon />, text: 'Company Settings' },
            { to: '/alexxcansols/usermanagement', icon: <SecurityOutlinedIcon />, text: 'User Management' },
        ],
    },
    {
        title: 'Security Control',
        links: [
            { to: '/alexxcansols/profiles', icon: <PersonOutlineOutlinedIcon />, text: 'Profiles' },
            { to: '/alexxcansols/roles', icon: <GroupOutlinedIcon />, text: 'Roles And Sharing' },
        ],
    },
    {
        title: 'Business Master',
        links: [
            { to: '/alexxcansols/businessgroup', icon: <CategoryOutlinedIcon />, text: 'Business Group' },
            { to: '/alexxcansols/contactgroup', icon: <CategoryOutlinedIcon />, text: 'Contact Group' },
            { to: '/alexxcansols/contacttypes', icon: <CategoryOutlinedIcon />, text: 'Contact Types' },
        ],
    },
    {
        title: 'Status Master',
        links: [
            { to: '/alexxcansols/taskstatuses', icon: <DescriptionIcon />, text: 'Task Statuses' },
            { to: '/alexxcansols/ratings', icon: <DescriptionIcon />, text: 'Ratings' },
            { to: '/alexxcansols/statusesleads', icon: <DescriptionIcon />, text: 'Lead Statuses' },
            { to: '/alexxcansols/sourceslead', icon: <DescriptionIcon />, text: 'Lead Sources' },
            { to: '/alexxcansols/lossreasons', icon: <DescriptionIcon />, text: 'Loss Reasons' },
            { to: '/alexxcansols/priorities', icon: <DescriptionIcon />, text: 'Priorities' },
        ],
    },
    {
        title: 'Media & Communication',
        links: [
            { to: '/alexxcansols/blogpost', icon: <ArticleIcon />, text: 'Blog Posts' },
            { to: '/alexxcansols/newsupdates', icon: <CampaignIcon />, text: 'News Updates' },
            { to: '/alexxcansols/casestudies', icon: <ArticleIcon />, text: 'Case Studies' },
            { to: '/alexxcansols/feedback', icon: <FeedbackIcon />, text: 'Feedback' },
            { to: '/alexxcansols/careers', icon: <WorkIcon />, text: 'Careers' },
        ],
    },
    {
        title: 'Customization',
        links: [
            { to: '/alexxcansols/colorplate', icon: <ColorLensOutlinedIcon />, text: 'Color Plate' },
        ],
    },
];
const cardsPartner = [
    {
        title: 'GENERAL',
        links: [
            { to: '/partner/personalsettings', icon: <PersonOutlineOutlinedIcon />, text: 'Personal Settings' },
            { to: '/partner/mycompany', icon: <BusinessOutlinedIcon />, text: 'Company Settings' },
            { to: '/partner/usermanagement', icon: <SecurityOutlinedIcon />, text: 'User Management' },
        ],
    },
    {
        title: 'Security Control',
        links: [
            { to: '/partner/profiles', icon: <PersonOutlineOutlinedIcon />, text: 'Profiles' },
            { to: '/partner/roles', icon: <GroupOutlinedIcon />, text: 'Roles And Sharing' },
        ],
    },
    {
        title: 'Business Master',
        links: [
            { to: '/partner/businessgroup', icon: <CategoryOutlinedIcon />, text: 'Business Group' },
            { to: '/partner/contactgroup', icon: <CategoryOutlinedIcon />, text: 'Contact Group' },
            { to: '/partner/contacttypes', icon: <CategoryOutlinedIcon />, text: 'Contact Types' },
        ],
    },
    {
        title: 'Status Master',
        links: [
            { to: '/partner/taskstatuses', icon: <DescriptionIcon />, text: 'Task Statuses' },
            { to: '/partner/ratings', icon: <DescriptionIcon />, text: 'Ratings' },
            { to: '/partner/statusesleads', icon: <DescriptionIcon />, text: 'Lead Statuses' },
            { to: '/partner/sourceslead', icon: <DescriptionIcon />, text: 'Lead Sources' },
            { to: '/partner/lossreasons', icon: <DescriptionIcon />, text: 'Loss Reasons' },
            { to: '/partner/priorities', icon: <DescriptionIcon />, text: 'Priorities' },
        ],
    },
    {
        title: 'Customization',
        links: [
            { to: '/partner/colorplate', icon: <ColorLensOutlinedIcon />, text: 'Color Plate' },
        ],
    },
];

const ResponsiveCards = () => {
    const [businessProfile, setBusinessProfile] = useState(null);

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");

        if (userDataString) {
            try {
                const userData = JSON.parse(userDataString);
                const profile = userData?.authUser?.businessProfile;
                setBusinessProfile(profile);
            } catch (error) {
                console.error("Invalid userData in sessionStorage:", error);
            }
        }
    }, []);

    // Decide which cards to render
    const cardsToRender = useMemo(() => {
        if (businessProfile === "owner") {
            return cardsAlexxcansols;
        } else if (businessProfile === "partner") {
            return cardsPartner;
        } else {
            return cards; // default
        }
    }, [businessProfile]);


    return (
        <div>

            <ContentWrapper style={{ marginTop: '0px' }}>
                <CardContent>
                    <Heading variant="h4" style={{ paddingBottom: '10px' }}>
                        {t("Setup")}
                    </Heading>
                    <Grid container spacing={2}>
                        {cardsToRender.map((card, index) => (
                            <Grid item key={index} xs={12} sm={6} md={3}>
                                <CustomCard variant="outlined">
                                    <CardBody>
                                        <Heading variant="h5">{t(card.title)}</Heading>
                                        {card.links.map((link, linkIndex) => (
                                            <Typography key={linkIndex} variant="body2">
                                                <CustomLink to={link.to}>
                                                    <span style={{ fontSize: "15px", marginTop: "2px" }}> {link.icon}  </span> &nbsp; {t(link.text)}
                                                </CustomLink>
                                            </Typography>
                                        ))}
                                    </CardBody>
                                    <br />
                                </CustomCard>
                            </Grid>
                        ))}
                    </Grid>
                </CardContent>
                <br />
            </ContentWrapper>
        </div>
    );
};

export default ResponsiveCards;
